<template>
    <div class="askBox"
         id="moveDiv"
         :style="style"
         @mousedown="down" @touchstart="down"
         @mousemove="move" @touchmove.prevent="move"
         @mouseup="end" @touchend="end"
    >
      <img src="../../assets/img/sanboIcon/kefu.png" @click="goKefu"
           alt="">
      <div @click="goZk" v-if="isZk">
        <img src="../../assets/img/sanboIcon/zkBack.png" alt="">
        <p class="color_main fs12 flex aic jcc">返回云医康</p>
      </div>
    </div>
</template>

<script>
   import {getParamsFromUrl} from "../../lib/utils"
    export default {
        name: "online-kefu",
        data(){
            return {
                flags:false,
                position: { x: 0, y: 0 }, //悬浮框位置
                isZk:false,
                style:{
                    height:65 + 'px'
                },
                nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: ''//悬浮框位置
            }
        },
        created(){
            let urlParams = getParamsFromUrl(location.href);
            let {query = {}} = urlParams;
            console.log(query)
            this.isZk = query.sourceurl ? true : false
            if(this.isZk){
                this.style = {
                    height:180 + 'px'
                }
            }
        },
        methods:{
            //咨询客服
            goKefu(){
                let urlParams = getParamsFromUrl(location.href);
                let {query = {}} = urlParams;
                let hosId = query.hosId
                let url = 'https://work.weixin.qq.com/kfid/kfc47b13ea3e5c20c9f'
                let tmp = {
                    '1100010001':'https://work.weixin.qq.com/kfid/kfc47b13ea3e5c20c9f',
                    '1100010002':'https://dht.zoosnet.net/LR/Chatpre.aspx?id=DHT99021961&lng=cn', //昆明
                    '1100010003':'https://cs-wechat.sbnk.cn/download/zaixiankefu.jpg' //福建
                }
                if(hosId){
                    url = tmp[hosId]
                }
                window.open(url);
            },
            goZk(){
                let urlParams = getParamsFromUrl(location.href);
                let {query = {}} = urlParams;
                let sourceurl = query.sourceurl + '&index=3'
                window.open(sourceurl);
            },
            // 实现移动端拖拽
            down(){
                this.flags = true;
                let touch;
                if(event.touches){
                    touch = event.touches[0];
                }else {
                    touch = event;
                }
                this.position.x = touch.clientX;
                this.position.y = touch.clientY;
                this.dx = moveDiv.offsetLeft;
                this.dy = moveDiv.offsetTop;
            },
            move(){
                console.log('【move】')
                if(this.flags){
                    let touch ;
                    if(event.touches){
                        touch = event.touches[0];
                    }else {
                        touch = event;
                    }
                    this.nx = touch.clientX - this.position.x;
                    this.ny = touch.clientY - this.position.y;
                    this.xPum = this.dx+this.nx;
                    this.yPum = this.dy+this.ny;
                    moveDiv.style.left = this.xPum+"px";
                    moveDiv.style.top = this.yPum +"px";
                    if(this.xPum < 0){
                        moveDiv.style.left = 0 + "px";
                    }
                    if(this.yPum < 0){
                        moveDiv.style.top = 0 +"px";
                    }
                    if(this.xPum >= document.body.clientWidth - 65){
                        moveDiv.style.left = document.body.clientWidth - 65 + 'px';
                    }
                    let y = this.isZk ? 180 : 65
                    if(this.yPum  >= document.body.clientHeight - y){
                        moveDiv.style.top = document.body.clientHeight - y + "px";
                    }
                }

            },
            //鼠标释放时候的函数
            end(){
                console.log('【end】')
                this.flags = false;
            },
        }
    }
</script>

<style lang="scss">
  @import "../../style/var";
  .askBox {
    position: absolute;
    bottom: 400px;
    right: 0;
    z-index: 99999;
    width: 130px;
    img {
      height: 130px;
      width: 130px;
    }
    p{
      color: $mainColor;
      margin-top: -5px !important;
    }
  }

  .noScroll{
     overflow-y: hidden !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/online-kefu.vue